import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email === 'admin@dqcc.ae' && password === 'Diamond@1522') {
      login();
      navigate('/dashboard');
    } else {
      alert('Invalid credentials');
    }
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-[#23A19B] via-emerald-400 to-blue-500 py-12 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(20px); }
        }
        @keyframes pulse-glow {
          0%, 100% { opacity: 0.5; }
          50% { opacity: 1; }
        }
        @keyframes slide-in-down {
          from { opacity: 0; transform: translateY(-30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes slide-in-up {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes scale-in {
          from { opacity: 0; transform: scale(0.9); }
          to { opacity: 1; transform: scale(1); }
        }
        .animate-float { animation: float 3s ease-in-out infinite; }
        .animate-pulse-glow { animation: pulse-glow 2s ease-in-out infinite; }
        .animate-slide-in-down { animation: slide-in-down 0.6s ease-out; }
        .animate-slide-in-up { animation: slide-in-up 0.6s ease-out 0.1s backwards; }
        .animate-scale-in { animation: scale-in 0.5s ease-out; }
      `}</style>

      {/* Animated Background Circles */}
      <div className="absolute top-10 left-10 w-32 h-32 bg-white/10 rounded-full animate-float blur-xl"></div>
      <div className="absolute bottom-10 right-10 w-40 h-40 bg-white/10 rounded-full animate-float blur-xl" style={{ animationDelay: '1s' }}></div>
      <div className="absolute top-1/2 left-1/3 w-24 h-24 bg-green-300/20 rounded-full animate-pulse-glow blur-2xl"></div>

      {/* Main Container */}
      <div className="max-w-md w-full space-y-8 animate-scale-in relative z-10">
        {/* Logo Section */}
        <div className="flex justify-center animate-slide-in-down">
          <div className="relative w-24 h-24 animate-float">
            <img
              src="/logo2.png"
              alt="Company Logo"
              className="w-full h-full object-contain drop-shadow-2xl"
            />
            <div className="absolute inset-0 bg-white/20 rounded-full animate-pulse-glow blur-lg"></div>
          </div>
        </div>

        {/* Header */}
        <div className="animate-slide-in-down">
          <h1 className="text-center text-4xl font-bold text-white mb-2 drop-shadow-lg">
            Diamond Quality
          </h1>
          <h2 className="text-center text-2xl font-semibold text-emerald-50 drop-shadow-lg">
            Constructions
          </h2>
          <p className="text-center text-emerald-100 text-sm mt-2 font-medium">
            🇦🇪 Sharjah, UAE
          </p>
        </div>

        {/* Welcome Text */}
        <div className="text-center animate-slide-in-down" style={{ animationDelay: '0.2s' }}>
          <p className="text-white/90 text-lg font-semibold">Welcome Back</p>
          <p className="text-white/70 text-sm">Sign in to access your account</p>
        </div>

        {/* Form */}
        <form className="mt-8 space-y-6 animate-slide-in-up" onSubmit={handleSubmit}>
          <input type="hidden" name="remember" defaultValue="true" />

          {/* Input Fields */}
          <div className="rounded-lg shadow-2xl overflow-hidden bg-white/95 backdrop-blur-md space-y-0">
            <div className="px-6 py-4 border-b border-gray-200">
              <label htmlFor="email-address" className="sr-only">Email address</label>
              <input
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="w-full bg-transparent border-0 focus:outline-none text-gray-900 placeholder-gray-500 font-medium"
                placeholder="user id"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="px-6 py-4">
              <label htmlFor="password" className="sr-only">Password</label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className="w-full bg-transparent border-0 focus:outline-none text-gray-900 placeholder-gray-500 font-medium"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          {/* Checklist & Link */}
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <input
                id="remember-me"
                name="remember-me"
                type="checkbox"
                className="h-4 w-4 rounded border-white/30 bg-white/20 text-white focus:ring-white"
              />
              <label htmlFor="remember-me" className="ml-2 block text-sm text-white/80">
                Remember me
              </label>
            </div>
            <div className="text-sm">
              <a href="#" className="font-medium text-white hover:text-emerald-100 transition-colors duration-200">
                Forgot password?
              </a>
            </div>
          </div>

          {/* Sign In Button */}
          <div>
            <button
              type="submit"
              className="w-full flex justify-center items-center py-3 px-4 border border-transparent text-base font-bold rounded-lg text-[#23A19B] bg-gradient-to-r from-white to-emerald-50 hover:from-emerald-50 hover:to-white shadow-xl hover:shadow-2xl focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-emerald-600 transition-all duration-200 transform hover:scale-105"
            >
              <span>🚀</span>
              <span className="ml-2">Sign In</span>
            </button>
          </div>

          {/* Demo Credentials */}
          {/* <div className="text-center text-xs text-white/70 bg-white/10 backdrop-blur-sm rounded-lg p-3 border border-white/20">
            <p className="font-semibold text-white/80 mb-1">Demo Credentials</p>
            <p>📧 admin@dqcc.ae</p>
            <p>🔑 1234</p>
          </div> */}
        </form>

        {/* Footer */}
        <div className="text-center text-white/60 text-xs">
          <p>© 2026 Diamond Quality Constructions</p>
          {/* <p>Secure Login - UAE FTA Compliant</p> */}
        </div>
      </div>
    </div>
  );
};

export default LoginPage;